import { Button } from '@graftcode/design-system'

import { ACADEMY_NAV_SECTIONS } from '../../const/academyNavSections.const'
import type { MobileNavigationState } from '../../hooks/useMobileNavigation'
import { CategorySection } from '../CategorySection'

import styles from '../../../../MobileMenu.module.scss'

const DOCUMENTATION_ITEM = ACADEMY_NAV_SECTIONS.flatMap((section) => section.items).find(
  (item) => item.id === 'documentation'
)

type DocumentationGroupProps = {
  nav: MobileNavigationState
  currentTutorialPath?: string
  expandedCategories: Set<string>
  onToggleCategory: (categoryPath: string) => void
}

export function DocumentationGroup({
  nav,
  currentTutorialPath,
  expandedCategories,
  onToggleCategory,
}: DocumentationGroupProps) {
  if (!DOCUMENTATION_ITEM) return null
  if (!nav.isDocumentationPage && nav.isSubpage) return null

  return (
    <div className={styles.academySectionGroup}>
      {nav.isDocumentationPage ? (
        <div className={styles.academySectionHeader}>
          <span className={styles.academySectionHeaderLabel}>{DOCUMENTATION_ITEM.label}</span>
        </div>
      ) : (
        <Button
          variant="ghost"
          size="l"
          fullWidth
          icon={DOCUMENTATION_ITEM.icon}
          text={DOCUMENTATION_ITEM.label}
          onClick={() => nav.handleNavigationClick(nav.documentationHomePath)}
          className={styles.academyMainNavItem}
        />
      )}

      {nav.isDocumentationPage &&
        nav.hasTutorialSections &&
        (nav.rootArticles.length > 0 || nav.documentationCategoryTree.length > 0) && (
          <div className={styles.academySectionChildren}>
            {nav.rootArticles.map((section) => (
              <Button
                key={section.path}
                variant="ghost"
                size="l"
                fullWidth
                text={section.title}
                onClick={() => nav.handleSectionClick(section, nav.documentationBasePath)}
                className={`${styles.academyArticle} ${currentTutorialPath === section.path ? styles.active : ''}`}
                style={{ justifyContent: 'flex-start' }}
              />
            ))}
            {nav.documentationCategoryTree.map((category) => (
              <CategorySection
                key={category.path}
                category={category}
                basePath={nav.documentationBasePath}
                currentTutorialPath={currentTutorialPath}
                expandedCategories={expandedCategories}
                onToggleCategory={onToggleCategory}
                onSectionClick={nav.handleSectionClick}
              />
            ))}
          </div>
        )}
    </div>
  )
}
